import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import download from "downloadjs";

function formatNumber(n) {
  const str = n.toString();
  return str[1] ? str : `0${str}`;
}

export function formatTime(date) {
    return dayjs(date)
      .format("YYYY-MM-DD HH:mm:ss")
}

export function getDate(date, splitor = "/") {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}${splitor}${addZeroPrefix(month)}${splitor}${addZeroPrefix(
    day
  )}`;
}

/**
 * 返回时分秒/时分
 * @export
 * @param {*} date
 * @param {boolean} [withSecond=false]
 * @returns
 */
export function getTime(date, withSecond = false) {
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return withSecond
    ? `${addZeroPrefix(hour)}:${addZeroPrefix(minute)}:${addZeroPrefix(second)}`
    : `${addZeroPrefix(hour)}:${addZeroPrefix(minute)}`;
}

export function getFullDate(date) {
  return `${getDate(date)} ${getTime(date)}`;
}

export function isToday(date) {
  return date.toDateString() === new Date().toDateString();
}

/**
 * 个位数，加0前缀
 * @param {*} number
 * @returns
 */
function addZeroPrefix(number) {
  return number < 10 ? `0${number}` : number;
}

export function throttle(func, wait) {
  let timeout;
  return function() {
    let that = this;
    let args = arguments;

    if (!timeout) {
      timeout = setTimeout(function() {
        timeout = null;
        func.apply(that, args);
      }, wait);
    }
  };
}
export function formatDuration(time) {
  let interval = time;
  let continued = "";
  if (interval > 3600) {
    const hour = Math.floor(interval / 3600);
    continued += hour + "小时";
    interval -= hour * 3600;
  }
  if (interval > 60 && interval < 3600) {
    const min = Math.floor(interval / 60);
    continued += min + "分";
    interval -= min * 60;
  }
  if (interval < 60) {
    continued += Math.floor(interval) + "秒";
  }
  return continued;
}

export function isJSON(str) {
  if (typeof str === "string") {
    try {
      let obj = JSON.parse(str);
      return !!(typeof obj === "object" && obj);
    } catch (e) {
      return false;
    }
  }
}

export function downloadFile(data) {
  var anchor = document.createElement("a");
  if (data.download_path && data.download_path.length < 2048) {
    anchor.href = data.download_path;
    if (anchor.href.indexOf(data.download_path) !== -1) {
      var ajax = new XMLHttpRequest();
      ajax.open("GET", data.download_path, true);
      ajax.responseType = "blob";
      ajax.onload = function(e) {
        download(e.target.response, data.name, data.file_type);
      };
      setTimeout(function() {
        ajax.send();
      }, 0);
      return ajax;
    }
  }
}

export default {
  formatNumber,
  formatTime,
  getDate,
  throttle,
  formatDuration,
  isJSON,
  downloadFile
};
